import request from '@/util/request'
export default{
	//登录
	dologin(data){
		return request({url: '/login/dologin',method: 'post',data})		
	},	
	//退出登录
	logout(data){
		return request({url: '/login/Logout',method: 'post',data})		
	},
	//仪表台
	// reportAll(data){
	// 	return request({url: '/report/all',method: 'post',data})		
	// },
	
	reportAll(data){
		return request({url: '/report/traderBalanceAll',method: 'post',data})		
	},
	//仪表台 核销金额 和 提卡金额 查询接口
	verificationAndCardStats(data){
		return request({url: '/report/verificationAndCardStats',method: 'post',data})		
	},
	//仪表台 manager/report/productDataStats
	productDataStats(data){
		return request({url: '/report/productDataStats',method: 'post',data})		
	},
	//仪表台  导出数据
	exportProductDataStats(data){
		return request({url: '/report/exportProductDataStats',method: 'post',data})		
	},
	//客户管理 列表查询
	memberTrader(data){
		return request({url: '/member/trader',method: 'post',data})		
	},
	//客户管理  产品配置  可选配置项及已选配置项
	memberProductConfig(data){
		return request({url: '/member_product_config/getConfig',method: 'post',data})		
	},
	//客户管理  产品配置 删除配置项
	deleteConfig(data){
		return request({url: '/member_product_config/deleteConfig',method: 'post',data})		
	},
	//客户管理  产品配置  开关
	enableConfig(data){
		return request({url: '/member_product_config/enableConfig',method: 'post',data})		
	},
	//客户管理 产品配置 保存配置
	saveConfig(data){
		return request({url: '/member_product_config/saveConfig',method: 'post',data})		
	},
	
	//客户管理 新增客户
	// addTrader(data){
	// 	return request({url: '/member/addTrader',method: 'post',data})
	// },	
	
	addTrader(data){
		return request({url: '/member/addTraderAuto',method: 'post',data})
	},	
	
	//客户管理 编辑客户 /member/editTrader
	editTrader(data){
		return request({url: '/member/editTrader',method: 'post',data})
	},
	//余额调整
	
	setAmount(data){
		return request({url: '/member/setAmount',method: 'post',data})
	},
	//余额详情
	moneyChangeList(data){
		return request({url: '/member/moneyChangeList',method: 'post',data})
	},
	//余额详情 流水类型查询
	moneyChangeKindOptions(data){
		return request({url: '/member/moneyChangeKindOptions',method: 'post',data})
	},
	
	//删除客户	
	deleteTrader(data){
		return request({url: '/member/deleteTrader',method: 'post',data})
	},
	//客户管理  删除客户
	deleteTraderCompletely(data){
		return request({url: '/member/deleteTraderCompletely',method: 'post',data})
	},
	
	//客户管理  重置密钥
	resetTraderSecrets(data){
		return request({url: '/member/resetTraderSecrets',method: 'post',data})
	},
	//产品管理 产品列表
	productList(data){
		return request({url: '/product/productList',method: 'post',data})
	},
	//产品管理  新增产品
	addProduct(data){
		return request({url: '/product/add',method: 'post',data})
	},
	//产品管理 编辑 删除面值
	deleteDenomination(data){
		return request({url: '/product/deleteDenomination',method: 'post',data})
	},
	//产品管理  删除产品
	deleteProduct(data){
		return request({url: '/product/delete',method: 'post',data})
	},
	//产品管理  编辑产品
	editProduct(data){
		return request({url: '/product/edit',method: 'post',data})
	},
	
	//卡密管理 列表查询
	bagList(data){
		return request({url: '/Bag/bagList',method: 'post',data})
	},
	//卡密管理 新增卡包	
	addBag(data){
		return request({url: '/Bag/addBag',method: 'post',data})
	},
	//卡密管理  编辑卡包Bag/editBag
	editBag(data){
		return request({url: '/Bag/editBag',method: 'post',data})
	},
	//卡密查询
	cardList(data){
		return request({url: '/Bag/cardList',method: 'post',data})
	},

	//订单列表查询
	allList(data){
		return request({url: '/order/allList',method: 'post',data})
		
	},
	//订单管理  手动核销
	ensure(data){
		return request({url: '/order/ensureCard',method: 'post',data})
		
	},
	//订单管理  操作日志
	getOrderOperatorLog(data){
		return request({url: '/order/getOrderOperatorLog',method: 'post',data})
		
	},
	//设置 操作日志查询 user/getManagerOperators
	getManagerOperators(data){
		return request({url: '/user/getManagerOperators',method: 'post',data})
	},
	//设置 子账号设置  列表查询
	getUsers(data){
		return request({url: '/user/getUsers',method: 'post',data})
		
	},
	//设置 子账号设置  新增
	addUser(data){
		return request({url: '/user/addUser',method: 'post',data})
		
	},
	//设置 子账号设置  编辑
	setUser(data){
		return request({url: '/user/setUser',method: 'post',data})
		
	},
	//设置 子账号设置  删除
	delUser(data){
		return request({url: '/user/delUser',method: 'post',data})
		
	},
	//设置 子账号设置  重置密码
	setPassword(data){
		return request({url: '/user/setPassword',method: 'post',data})		
	},
	//全部锁定，解锁接口：manager/bag/batchChangeCards  参数：traderId   bagId   status  3 锁定 2 解锁
	batchChangeCards(data){
		return request({url: '/bag/batchChangeCards',method: 'post',data})
	},
	//运营后台：单个锁定，解锁接口：manager/bag/ChangeCardStatus 参数： traderId bagId cardId status 3 锁定 2 解锁
	ChangeCardStatus(data){
		return request({url: '/bag/ChangeCardStatus',method: 'post',data})
	},
	//提卡订单 面值查询
	getFaceValueList(data){
		return request({url: '/card_Order/getFaceValueList',method: 'post',data})
	},
	//提卡订单  列表查询
	cardOrderAllList(data){
		return request({url: '/card_Order/allList',method: 'post',data})
	},
	// 提卡订单  产品列表
	getProductList(data){
		return request({url: '/card_Order/getProductList',method: 'post',data})
	},
	//提卡订单  锁卡
	lockCard(data){
		return request({url: '/card_Order/lockCard',method: 'post',data})
	},
	//提卡订单  解锁
	unlockCard(data){
		return request({url: '/card_Order/unlockCard',method: 'post',data})
	},
	//获取取卡类型列表
	getOrderTypeList(data){
		return request({url: '/card_order/getOrderTypeList',method: 'post',data})
	},
	//产品管理 一键改变产品状态  1 开启  0 关闭
	batchSetProductStatus(data){
		return request({url: '/product/batchSetProductStatus',method: 'post',data})
	},

	//获取白名单列表manager/verifywhitelist/index?page=1&limit=10
	getWhiteList(data){
		return request({url: '/verify_whitelist/index',method: 'post',data})
	},
	//添加白名单manager/verifywhitelist/add
	addWhiteList(data){
		return request({url: '/verify_whitelist/add',method: 'post',data})
	},
	//删除白名单verify_whitelist/delete
	deleteWhiteList(data){
		return request({url: '/verify_whitelist/delete',method: 'post',data})
	},
	//获取非白名单核销次数verify_whitelist/getConfig
	getWhiteListConfig(data){
		return request({url: '/verify_whitelist/getConfig',method: 'post',data})
	},
	//更新非白名单核销次数 verify_whitelist/updateConfig
	updateWhiteListConfig(data){
		return request({url: '/verify_whitelist/updateConfig',method: 'post',data})
	},
	//编辑白名单/verifyWhitelist/edit
	editWhiteList(data){
		return request({url: '/verify_whitelist/edit',method: 'post',data})
	},
	//批量删除白名单verify_whitelist/batchDelete
	batchDeleteWhiteList(data){
		return request({url: '/verify_whitelist/batchDelete',method: 'post',data})
	},
	//停用  启用白名单verify_whitelist/updateStatus
	changeWhiteListStatus(data){
		return request({url: '/verify_whitelist/updateStatus',method: 'post',data})
	},
	//- `GET /manager/member/getCkConfig` - 获取商户CK配置
	getCkConfig(data){
		return request({url: '/member/getCkConfig',method: 'post',data})
	},
	// - `POST /manager/member/saveCkConfig` - 保存商户CK配置
	saveCkConfig(data){
		return request({url: '/member/saveCkConfig',method: 'post',data})
	},
	// - `POST /manager/member/checkCkValid` - 验证CK是否生效
	checkCkValid(data){
		return request({url: '/member/checkCkValid',method: 'post',data})
	},
	// - `GET /manager/member/trader` - 商户列表（支持CK状态筛选）
	// trader(data){
	// 	return request({url: '/member/trader',method: 'post',data})
	// },
	// ck配置 添加商户ck配置 member/addCkConfig
	addCkConfig(data){
		return request({url: '/member/addCkConfig',method: 'post',data})
	},
	
	//CK配置 删除配置 member/deleteCkConfig
	deleteCkConfig(data){
		return request({url: '/member/deleteCkConfig',method: 'post',data})
	},
	//更新ck配置 member/updateCkConfig
	updateCkConfig(data){
		return request({url: '/member/updateCkConfig',method: 'post',data})
	},
	//获取失效ck列表 （用于弹窗提醒） member/getInvalidCkList
	getInvalidCkList(data){
		return request({url: '/member/getInvalidCkList',method: 'post',data})
	},
	//查看产品的闲鱼链接列表 product/xianyuLinks
	getXianyu(data){
		return request({url: '/product/xianyuLinks',method: 'post',data})

	}
}